// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__mkPgJ","list":"styles_list__1Le6Y"};